import { useSelector } from 'react-redux';

export default () => {
  const { details = {} } = useSelector(
    ({ dashboard: { currentOrganization } }) => currentOrganization,
  );
  return details;
};
